import { render, staticRenderFns } from "./PStatusLabel.vue?vue&type=template&id=6d2a8893"
import script from "./PStatusLabel.vue?vue&type=script&lang=js"
export * from "./PStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports